import Card from '@/components/ui/Card'

export default function SponsorAthleteAbout() {
  return (
    <div className="space-y-8">
      <header className="space-y-2">
        <h1 className="text-3xl font-semibold text-cocoa">Sponsor an Athlete</h1>
        <span className="inline-flex items-center gap-2 rounded-full bg-shell px-3 py-1 text-sm font-medium uppercase tracking-wide text-cocoa/70">
          Preview — Coming soon
        </span>
        <p className="text-cocoa/70">
          Back youth athletics with equipment, fees, and travel. We’re coordinating with leagues to pilot the first sponsorships.
        </p>
      </header>
      <Card className="p-5 text-sm text-cocoa/80">
        Training plans, highlight reels, and budget transparency will help sponsors follow every win. Stay tuned as we build the roster and launch stories from student athletes.
      </Card>
    </div>
  )
}
